export function fontSizeToMultiplier(value) {
    switch (value) {
        case "xx-small":
            return 0.25;
        case "x-small":
            return 0.5;
        case "small":
            return 0.75;
        case "medium":
            return 1;
        case "large":
            return 1.25;
        case "x-large":
            return 1.5;
        case "xx-large":
            return 1.75;
        case "xxx-large":
            return 2;
        default:
            return 1;
    }
}
export const fonts = {
    Arial: {
        load: () => { },
        family: '"Arial", serif',
    },
    "Abril Fatface": {
        load: () => import("@fontsource/abril-fatface/index.css"),
        family: '"Abril Fatface", serif',
    },
    "Alex Brush": {
        load: () => import("@fontsource/alex-brush/index.css"),
        family: '"Alex Brush", cursive',
    },
    Archivo: {
        load: () => import("@fontsource/archivo/index.css"),
        family: '"Archivo", sans-serif',
    },
    "Archivo Narrow": {
        load: () => import("@fontsource/archivo-narrow/index.css"),
        family: '"Archivo Narrow", sans-serif',
    },
    Asap: {
        load: () => import("@fontsource/asap/index.css"),
        family: '"Asap", sans-serif',
    },
    B612: {
        load: () => import("@fontsource/b612/index.css"),
        family: '"B612", sans-serif',
    },
    "Bad Script": {
        load: () => import("@fontsource/bad-script/index.css"),
        family: '"Bad Script", cursive',
    },
    "Barlow Semi Condensed": {
        load: () => import("@fontsource/barlow-semi-condensed/index.css"),
        family: '"Barlow Semi Condensed", sans-serif',
    },
    Basic: {
        load: () => import("@fontsource/basic/index.css"),
        family: '"Basic", sans-serif',
    },
    Bellefair: {
        load: () => import("@fontsource/bellefair/index.css"),
        family: '"Bellefair", serif',
    },
    "Bodoni Moda": {
        load: () => import("@fontsource/bodoni-moda/index.css"),
        family: '"Bodoni Moda", serif',
    },
    Brawler: {
        load: () => import("@fontsource/brawler/index.css"),
        family: '"Brawler", serif',
    },
    Caladea: {
        load: () => import("@fontsource/caladea/index.css"),
        family: '"Caladea", serif',
    },
    Calibri: {
        load: () => { },
        family: '"Calibri", serif',
    },
    "Carrois Gothic": {
        load: () => import("@fontsource/carrois-gothic/index.css"),
        family: '"Carrois Gothic", sans-serif',
    },
    Cookie: {
        load: () => import("@fontsource/cookie/index.css"),
        family: '"Cookie", cursive',
    },
    Courgette: {
        load: () => import("@fontsource/courgette/index.css"),
        family: '"Courgette", cursive',
    },
    "Dancing Script": {
        load: () => import("@fontsource/dancing-script/index.css"),
        family: '"Dancing Script", cursive',
    },
    "EB Garamond": {
        load: () => import("@fontsource/eb-garamond/index.css"),
        family: '"EB Garamond", serif',
    },
    Epilogue: {
        load: () => import("@fontsource/epilogue/index.css"),
        family: '"Epilogue", sans-serif',
    },
    Exo: {
        load: () => import("@fontsource/exo/index.css"),
        family: '"Exo", sans-serif',
    },
    Fasthand: {
        load: () => import("@fontsource/fasthand/index.css"),
        family: '"Fasthand", cursive',
    },
    Freehand: {
        load: () => import("@fontsource/freehand/index.css"),
        family: '"Freehand", cursive',
    },
    "Gilda Display": {
        load: () => import("@fontsource/gilda-display/index.css"),
        family: '"Gilda Display", serif',
    },
    "Gothic A1": {
        load: () => import("@fontsource/gothic-a1/index.css"),
        family: '"Gothic A1", sans-serif',
    },
    "Great Vibes": {
        load: () => import("@fontsource/great-vibes/index.css"),
        family: '"Great Vibes", cursive',
    },
    Heebo: {
        load: () => import("@fontsource/heebo/index.css"),
        family: '"Heebo", sans-serif',
    },
    Helvetica: {
        load: () => { },
        family: '"Helvetica", sans-serif',
    },
    "IBM Plex Sans": {
        load: () => import("@fontsource/ibm-plex-sans/index.css"),
        family: '"IBM Plex Sans", sans-serif',
    },
    "IBM Plex Sans KR": {
        load: () => import("@fontsource/ibm-plex-sans-kr/index.css"),
        family: '"IBM Plex Sans KR", sans-serif',
    },
    "Indie Flower": {
        load: () => import("@fontsource/indie-flower/index.css"),
        family: '"Indie Flower", cursive',
    },
    Itim: {
        load: () => import("@fontsource/itim/index.css"),
        family: '"Itim", cursive',
    },
    "Jockey One": {
        load: () => import("@fontsource/jockey-one/index.css"),
        family: '"Jockey One", sans-serif',
    },
    "Josefin Sans": {
        load: () => import("@fontsource/josefin-sans/index.css"),
        family: '"Josefin Sans", sans-serif',
    },
    Karla: {
        load: () => import("@fontsource/karla/index.css"),
        family: '"Karla", sans-serif',
    },
    Karma: {
        load: () => import("@fontsource/karma/index.css"),
        family: '"Karma", serif',
    },
    "Kaushan Script": {
        load: () => import("@fontsource/kaushan-script/index.css"),
        family: '"Kaushan Script", cursive',
    },
    "League Gothic": {
        load: () => import("@fontsource/league-gothic/index.css"),
        family: '"League Gothic", sans-serif',
    },
    "League Spartan": {
        load: () => import("@fontsource/league-spartan/index.css"),
        family: '"League Spartan", sans-serif',
    },
    "Martel Sans": {
        load: () => import("@fontsource/martel-sans/index.css"),
        family: '"Martel Sans", sans-serif',
    },
    Mate: {
        load: () => import("@fontsource/mate/index.css"),
        family: '"Mate", serif',
    },
    Merriweather: {
        load: () => import("@fontsource/merriweather/index.css"),
        family: '"Merriweather", serif',
    },
    Monaco: {
        load: () => { },
        family: '"Monaco", serif',
    },
    Montserrat: {
        load: () => import("@fontsource/montserrat/index.css"),
        family: '"Montserrat", sans-serif',
    },
    "Nanum Gothic Coding": {
        load: () => import("@fontsource/nanum-gothic-coding/index.css"),
        family: '"Nanum Gothic Coding", monospace',
    },
    "Nothing You Could Do": {
        load: () => import("@fontsource/nothing-you-could-do/index.css"),
        family: '"Nothing You Could Do", cursive',
    },
    "Noto Sans": {
        load: () => import("@fontsource/noto-sans/index.css"),
        family: '"Noto Sans", sans-serif',
    },
    "Noto Sans Display": {
        load: () => import("@fontsource/noto-sans-display/index.css"),
        family: '"Noto Sans Display", sans-serif',
    },
    "Noto Serif": {
        load: () => import("@fontsource/noto-serif/index.css"),
        family: '"Noto Serif", serif',
    },
    "Open Sans": {
        load: () => import("@fontsource/open-sans/index.css"),
        family: '"Open Sans", sans-serif',
    },
    Oswald: {
        load: () => import("@fontsource/oswald/index.css"),
        family: '"Oswald", sans-serif',
    },
    Overpass: {
        load: () => import("@fontsource/overpass/index.css"),
        family: '"Overpass", sans-serif',
    },
    Overlock: {
        load: () => import("@fontsource/overlock/index.css"),
        family: '"Overlock", sans-serif',
    },
    Oxygen: {
        load: () => import("@fontsource/oxygen/index.css"),
        family: '"Oxygen", sans-serif',
    },
    Philosopher: {
        load: () => import("@fontsource/philosopher/index.css"),
        family: '"Philosopher", serif',
    },
    Playball: {
        load: () => import("@fontsource/playball/index.css"),
        family: '"Playball", cursive',
    },
    "Playfair Display": {
        load: () => import("@fontsource/playfair-display/index.css"),
        family: '"Playfair Display", serif',
    },
    Poppins: {
        load: () => import("@fontsource/poppins/index.css"),
        family: '"Poppins", sans-serif',
    },
    "PT Serif": {
        load: () => import("@fontsource/pt-serif/index.css"),
        family: '"PT Serif", serif',
    },
    "Public Sans": {
        load: () => import("@fontsource/public-sans/index.css"),
        family: '"Public Sans", sans-serif',
    },
    Quando: {
        load: () => import("@fontsource/quando/index.css"),
        family: '"Quando", serif',
    },
    Quattrocento: {
        load: () => import("@fontsource/quattrocento/index.css"),
        family: '"Quattrocento", serif',
    },
    "Quattrocento Sans": {
        load: () => import("@fontsource/quattrocento-sans/index.css"),
        family: '"Quattrocento Sans", sans-serif',
    },
    Questrial: {
        load: () => import("@fontsource/questrial/index.css"),
        family: '"Questrial", sans-serif',
    },
    Raleway: {
        load: () => import("@fontsource/raleway/index.css"),
        family: '"Raleway", sans-serif',
    },
    "Red Hat Display": {
        load: () => import("@fontsource/red-hat-display/index.css"),
        family: '"Red Hat Display", sans-serif',
    },
    Roboto: {
        load: () => import("@fontsource/roboto/index.css"),
        family: '"Roboto", sans-serif',
    },
    "Roboto Condensed": {
        load: () => import("@fontsource/roboto-condensed/index.css"),
        family: '"Roboto Condensed", sans-serif',
    },
    "Roboto Slab": {
        load: () => import("@fontsource/roboto-slab/index.css"),
        family: '"Roboto Slab", serif',
    },
    Rubik: {
        load: () => import("@fontsource/rubik/index.css"),
        family: '"Rubik", sans-serif',
    },
    Sarala: {
        load: () => import("@fontsource/sarala/index.css"),
        family: '"Sarala", sans-serif',
    },
    Stoke: {
        load: () => import("@fontsource/stoke/index.css"),
        family: '"Stoke", serif',
    },
    Times: {
        load: () => { },
        family: '"Times", serif',
    },
    "Ubuntu Condensed": {
        load: () => import("@fontsource/ubuntu-condensed/index.css"),
        family: '"Ubuntu Condensed", sans-serif',
    },
    "Ysabeau Office": {
        load: () => import("@fontsource/ysabeau-office/index.css"),
        family: '"Ysabeau Office", sans-serif',
    },
    "Zen Antique Soft": {
        load: () => import("@fontsource/zen-antique-soft/index.css"),
        family: '"Zen Antique Soft", serif',
    },
    "Zen Kaku Gothic New": {
        load: () => import("@fontsource/zen-kaku-gothic-new/index.css"),
        family: '"Zen Kaku Gothic New", sans-serif',
    },
    "Zen Maru Gothic": {
        load: () => import("@fontsource/zen-maru-gothic/index.css"),
        family: '"Zen Maru Gothic", sans-serif',
    },
};
